import React, { useEffect, useState, useRef } from 'react';
import { Bell } from 'lucide-react';
import { NotificationPanel } from '../notification/NotificationPanel';
// Mock notifications data
const mockNotifications = [{
  id: '1',
  type: 'message',
  title: 'Yeni Mesaj',
  message: 'Zeynep Öğretmen size yeni bir mesaj gönderdi.',
  time: '5 dakika önce',
  read: false,
  link: '/yonetici/mesajlar'
}, {
  id: '2',
  type: 'forum',
  title: 'Forum Yanıtı',
  message: 'Mehmet K., "Öğrencilere nasıl daha etkili motivasyon sağlayabiliriz?" konusuna yanıt yazdı.',
  time: '30 dakika önce',
  read: false,
  link: '/yonetici/forum'
}, {
  id: '3',
  type: 'homework',
  title: 'Ödev Hatırlatması',
  message: '8-A sınıfı için "Matematik - Üslü Sayılar" ödevinin son teslim tarihi yarın.',
  time: '2 saat önce',
  read: true,
  link: '/yonetici/ogrenciler'
}];
export function Header() {
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState(mockNotifications);
  const notificationRef = useRef<HTMLDivElement>(null);
  const unreadCount = notifications.filter(n => !n.read).length;
  const handleMarkAllAsRead = () => {
    setNotifications(notifications.map(notification => ({
      ...notification,
      read: true
    })));
  };
  // Close notifications panel when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (notificationRef.current && !notificationRef.current.contains(event.target as Node)) {
        setShowNotifications(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <header className="h-24 border-b border-gray-800/40 bg-[#0D1117]/80 backdrop-blur-md flex items-center justify-between px-6 md:px-8 lg:px-10" data-id="element-144">
      <div className="text-xl text-white" data-id="element-145">
        Hoş geldin,{' '}
        <span className="font-medium bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 text-transparent bg-clip-text" data-id="element-146">
          Ahmet
        </span>
      </div>
      <div className="flex items-center space-x-8" data-id="element-147">
        <div className="relative" ref={notificationRef} data-id="element-148">
          <button className="relative hover:text-white transition-colors p-1" onClick={() => setShowNotifications(!showNotifications)} data-id="element-149">
            <Bell className="w-10 h-10 text-purple-400 hover:text-white transition-colors" data-id="element-150" />
            {unreadCount > 0 && <span className="absolute -top-1 -right-1 flex h-4 w-4" data-id="element-151">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75" data-id="element-152"></span>
                <span className="relative inline-flex rounded-full h-4 w-4 bg-purple-500" data-id="element-153"></span>
              </span>}
          </button>
          {showNotifications && <NotificationPanel notifications={notifications} onClose={() => setShowNotifications(false)} onMarkAllAsRead={handleMarkAllAsRead} data-id="element-154" />}
        </div>
        <div className="relative" data-id="element-155">
          <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=80&h=80&fit=crop&crop=faces" alt="Yönetici Profili" className="h-16 w-16 rounded-full object-cover ring-2 ring-purple-500/50" data-id="element-156" />
        </div>
      </div>
    </header>;
}